import { useContext } from 'react';
import { TicketsContext } from './TicketsContext';

// ----------------------------------------------------------------------

const useTicketsContext = () => useContext(TicketsContext);

export default useTicketsContext;
